import { conditionMessages } from './condition-messages.js'
import { enumOptionsEs } from './enum-options.js'
import { sectionCatalogEs } from './section-catalog.js'

export const es = {
  visualGameStudio: {
    brand: 'Visual Game Studio',
    localizationUnsupported: 'Esta versión histórica no contiene datos compilados completos y no se puede localizar. Selecciona otra versión.',
    seal: 'VG',
    viewport: {
      title: 'Usa una pantalla más grande',
      body: 'Visual Game Studio es una herramienta de escritorio. Usa una pantalla de al menos 1024px de ancho para editar packs.',
    },
    nav: { projects: 'Proyectos', editor: 'Editor', assets: 'Recursos', versions: 'Versiones', turnVideos: 'Vídeos de turnos', runChain: 'Cadena de partida', localization: 'Idiomas', help: 'Ayuda', settings: 'Ajustes' },
    auth: { title: 'Entrar al Studio', subtitle: 'Usa tu cuenta para gestionar guiones, recursos, versiones y publicación.', email: 'Correo', password: 'Contraseña', login: 'Entrar', logout: 'Salir', loggingIn: 'Entrando', failed: 'No se pudo iniciar sesión' },
    topbar: { preview: 'Previsualizar', publish: 'Publicar', noProject: 'Sin proyecto', account: 'Cuenta', themeLight: 'Tema claro', themeDark: 'Tema oscuro' },
    projects: {
      title: 'Mis proyectos',
      subtitle: 'Gestiona borradores, estado de publicación y visibilidad.',
      tags: 'Etiquetas', bulkTags: 'Etiquetas por lotes', bulkTagsPlaceholder: 'Fantasía, Romance, Misterio', applyToFiltered: 'Aplicar a {count} filtrados', bulkTagsApplied: 'Etiquetas actualizadas en {count} guiones',
      newProject: 'Nuevo proyecto',
      search: 'Buscar proyectos',
      filterAll: 'Todos',
      filterDraft: 'Borrador',
      filterPublished: 'Publicado',
      sortUpdated: 'Última actualización',
      sortEpisode: 'Orden de niveles',
      levelNumber: 'Nivel {number}',
      emptyTitle: 'Aún no hay proyectos',
      emptyBody: 'Crea el primer pack y entra al editor estructurado.',
      edit: 'Editar',
      duplicate: 'Duplicar',
      rename: 'Renombrar',
      visibility: 'Visibilidad',
      delete: 'Archivar/Eliminar',
      createTitle: 'Nuevo proyecto',
      editTitle: 'Editar proyecto',
      projectTitle: 'Título',
      seriesId: 'ID de la serie',
      seriesIdPlaceholder: 'p. ej. painted_skin',
      seriesTitle: 'Título de la serie',
      scriptTitle: 'Título de la historia',
      seriesTitlePlaceholder: 'p. ej. Painted Skin',
      episodeNo: 'Número de nivel',
      episodeNoPlaceholder: '1',
      seriesHint: 'Deja los tres campos vacíos para un nivel independiente. Para una serie, completa los tres y usa un número único.',
      newSeries: 'Nueva historia',
      createSeries: 'Crear historia',
      createSeriesTitle: 'Nueva historia',
      createSeriesHint: 'Al crear la historia también se crea su primer nivel. Después podrás añadir más niveles.',
      firstLevelTitle: 'Título del primer nivel',
      firstLevelTitlePlaceholder: 'p. ej. Entrar al templo',
      seriesCreated: 'Historia y primer nivel creados',
      seriesSection: 'Historias',
      standaloneSection: 'Niveles independientes',
      manageLevels: 'Gestionar niveles',
      levelCount: '{count} niveles',
      newLevel: 'Nuevo nivel',
      newStandalone: 'Nuevo nivel independiente',
      backToSeries: 'Volver a historias',
      seriesLevelsSubtitle: 'Gestiona en orden los {count} niveles de esta historia.',
      belongsToSeries: 'Historia',
      searchLevels: 'Buscar niveles de esta historia',
      searchStandalone: 'Buscar niveles independientes',
      noMatchingLevels: 'No hay niveles coincidentes',
      locale: 'Idioma',
      associateLevel: 'Vincular nivel existente',
      associateLevelTitle: 'Vincular nivel independiente',
      associateLevelHint: 'Mueve el nivel independiente original a {series} sin crear una copia ni cambiar su contenido.',
      standaloneLevel: 'Nivel independiente',
      selectStandaloneLevel: 'Selecciona un nivel independiente',
      levelAssociated: 'Nivel vinculado a la historia',
      associateLevelFailed: 'No se pudo vincular el nivel',
      private: 'Privado',
      public: 'Público',
      unlisted: 'No listado',
      save: 'Guardar',
      cancel: 'Cancelar',
      creating: 'Creando',
      saving: 'Guardando',
      loading: 'Cargando proyectos',
      loadFailed: 'Error al cargar proyectos',
      createFailed: 'Error al crear',
      updateFailed: 'Error al guardar',
      duplicateFailed: 'Error al duplicar',
      deleteFailed: 'Error al eliminar',
      created: 'Proyecto creado',
      updated: 'Proyecto guardado',
      duplicated: 'Proyecto duplicado',
      archived: 'Proyecto archivado',
      deleted: 'Proyecto eliminado',
      confirmDelete: 'Confirma la acción. Los packs publicados o con datos de usuario se archivan; los borradores sin uso se eliminan.',
      confirmTextLabel: 'Escribe {title} para confirmar',
      scenes: 'Escenas',
      endings: 'Finales',
      updatedAt: 'Actualizado',
    },
    status: { draft: 'DRAFT', published: 'PUBLISHED', archived: 'ARCHIVED', unknown: 'UNKNOWN' },
    enumOptions: enumOptionsEs,
    sectionGroups: { basic: 'Base', state: 'Valores y estado', world: 'Mundo', cast: 'Personajes y objetos', info: 'Información', gameplay: 'Juego', ending: 'Finales', assets: 'Recursos' },
    editor: {
      title: 'Editor de guion',
      subtitle: 'Mantén mapas, personajes, misiones, reglas, finales y medios por sección.',
      section: 'Sección',
      readonly: 'No tienes permiso para editar este proyecto',
      unsaved: 'Cambios sin guardar',
      saved: 'Guardado',
      save: 'Guardar',
      revert: 'Revertir',
      savedToast: 'Sección guardada',
      saveFailed: 'Error al guardar',
      discardConfirm: 'Hay cambios sin guardar. ¿Descartarlos?',
      discardTitle: 'Descartar cambios sin guardar',
      discardBody: 'Esta sección tiene cambios sin guardar. Si sales ahora no se escribirán en la base de datos.',
      stayEditing: 'Seguir editando',
      discardCta: 'Descartar cambios',
      deleteEntityTitle: 'Eliminar elemento',
      deleteEntityBody: 'El elemento se quitará de esta sección y se guardará en la base de datos al guardar.',
      deleteEntityBlocked: 'Este elemento tiene {count} referencias. Elimínalas antes de borrarlo.',
      deleteEntityConfirmLabel: 'Escribe {label} para confirmar la eliminación.',
      deleteEntityCta: 'Eliminar elemento',
      recentChanges: 'Cambios recientes',
      recentChangesHint: 'Muestra registros de auditoría de base de datos para este borrador.',
      auditLoading: 'Cargando cambios',
      auditLoadFailed: 'Error al cargar cambios',
      noRecentChanges: 'Aún no hay cambios',
      auditActions: { section_update: 'Sección guardada', asset_upload: 'Recurso subido', asset_delete: 'Recurso eliminado', compile: 'Compilado', publish: 'Publicado', rollback: 'Revertido' },
      focusedCheck: 'Validación enfocada',
      structuredTab: 'Estructurado',
      jsonTab: 'JSON',
      jsonHelp: 'Los cambios JSON se sincronizan con el formulario cuando son validos.',
      jsonInvalid: 'JSON invalido',
      addRow: 'Añadir',
      searchOptions: 'Search options',
      dragRow: 'Arrastrar para ordenar',
      duplicateRow: 'Duplicar',
      removeRow: 'Quitar',
      emptyRows: 'Sin filas',
      item: 'Elemento',
      noId: 'Sin ID',
      sections: {
        mapLocations: 'Ubicaciones',
        mapGraph: 'Mapa de conexiones',
        npcs: 'NPCs',
        objects: 'Objetos',
        clues: 'Pistas',
        conclusions: 'Conclusiones',
        infoBlocks: 'Bloques de info',
        sceneEvents: 'Eventos',
        actionRules: 'Reglas de acción',
        endings: 'Finales',
        stateRegistry: 'Registro de estado',
        players: 'Personajes',
        quests: 'Misiones',
        mediaTags: 'Tags de media',
        videoReferences: 'Referencias para generar vídeo',
        stageRules: 'Reglas de escena',
        audioRules: 'Reglas de audio',
        voiceSettings: 'Configuración de voces',
        voiceSettingsHelp: 'Configura primero las voces predeterminadas; cada idioma puede sobrescribirlas, y los valores vacíos heredan la predeterminada.',
        audioMoodRules: 'Reglas de BGM',
        statSfxRules: 'SFX de stats',
        stateCgRules: 'Reglas de CG por estado',
        followupRules: 'CG posteriores',
      },
      stateWorkspace: {
        initialTitle: 'Valores iniciales',
        initialBody: 'Al crear una partida nueva, estos valores se escriben en el run: flags globales, estado NPC, progreso de misiones, estado de objetos e inventario inicial.',
        registryTitle: 'Registro de estado',
        registryBody: 'Es la ficha de referencia de las keys de estado. Explica qué significa cada key, quién la escribe, quién la lee y qué historia o regla afecta.',
        relationshipTitle: 'Relación',
        relationshipBody: 'Los valores iniciales definen qué es verdadero al empezar. El registro explica qué significa cada key. El registro no reemplaza los valores iniciales; ayuda con validaciones, referencias de reglas y mantenimiento.',
        openingValues: 'Valores iniciales',
        registeredKeys: 'Keys registradas',
        initialHint: 'Mantén solo los valores que deben existir al inicio. El estado NPC u objeto anidado se muestra como rutas con punto para alinearse con el registro.',
        registryHint: 'Registra cada key leída por reglas de acción, condiciones, KP o agentes. Fuentes e impacto claros facilitan depurar después.',
        registryTableTitle: 'Entradas del registro',
        unregisteredInitialKeys: 'Estas keys iniciales aún no tienen nota en el registro:',
        keyPurpose: 'Uso',
        noRegistryNote: 'Uso no registrado',
        noRegistryHint: 'Añade una key igual en el registro de estado para mostrar aquí su significado e impacto runtime.',
      },
      sceneWorkspace: {
        scenesGroup: 'Escenas',
        emptyScenes: 'Aún no hay escenas. Añade ubicaciones en Mapa primero.',
        noScene: 'Crea una escena en Mapa primero.',
        noDescription: 'Esta escena aún no tiene descripción.',
        unlocked: 'Desbloqueada al inicio',
        locked: 'Bloqueada',
        sceneObjects: 'Definiciones de objetos de escena',
        sceneClues: 'Pistas de escena',
        sceneInfoBlocks: 'Bloques de info de escena',
        sceneEvents: 'Eventos de escena',
        sceneActionRules: 'Reglas de escena',
        npcNote: 'Elige los NPC globales que aparecen en esta escena y edita su estado inicial de escena. Los perfiles completos siguen en NPC global.',
        objectNote: 'Edita objetos globales montados en esta escena. Las definiciones guardan en objects global y la colocación en map.locations[].objectIds.',
        clueNote: 'Esta vista filtra pistas globales para la escena actual. Las pistas nuevas se asignan automáticamente a esta escena.',
        infoNote: 'Esta vista filtra bloques de info por NPC presentes en esta escena.',
        eventNote: 'Esta vista filtra eventos por la escena actual. Al guardar, locationId será esta escena.',
        ruleNote: 'Esta vista filtra reglas de acción por escena. Las reglas nuevas reciben una condición location para evitar que sean globales.',
        tabs: {
          overview: 'Resumen',
          basic: 'Base',
          connections: 'Conexiones',
          npcs: 'NPC',
          objects: 'Objetos',
          clues: 'Pistas',
          infoBlocks: 'Info',
          sceneEvents: 'Eventos',
          actionRules: 'Reglas',
        },
        hints: {
          basic: 'Nombre, descripción, tipo y media de la escena.',
          connections: 'Enlaces de movimiento desde esta escena.',
          npcs: 'NPC presentes en esta escena y su estado inicial.',
          objects: 'Objetos globales montados en esta escena y sus definiciones.',
          clues: 'Pistas relacionadas con la escena, sus NPC u objetos.',
          infoBlocks: 'Información revelable y hechos ocultos de los NPC de escena.',
          sceneEvents: 'Eventos de entrada, descubrimiento o personalizados de esta escena.',
          actionRules: 'Reglas relacionadas con objetivos o condición location de esta escena.',
        },
      },
      mediaUsage: {
        title: 'Media usage',
        subtitle: 'Shows where each media asset is bound in the game flow. Saving writes these bindings into structured tables used by the game runtime.',
        missingAsset: 'This tag is missing from the asset manifest',
        opening: 'Home opening CG',
        endingBook: 'Ending book background',
        entryStage: 'Entry stage',
        entryStageIdle: 'Entry idle video',
        defaultStage: 'Default stage',
        defaultStageIdle: 'Default idle video',
        revealedStage: 'Revealed stage',
        revealedStageIdle: 'Revealed idle video',
        defaultBgm: 'Default BGM',
        editInMedia: 'Edit in Media global rules',
        editInMediaStageRules: 'Edit in Media stage rules',
        editInMediaAudioRules: 'Edit in Media audio rules',
        editInMediaStateCgs: 'Edit in Media state CG rules',
        editInMediaFollowups: 'Edit in Media follow-ups',
        editInMap: 'Edit in Map location media',
        editInNpcs: 'Edit in NPC media tag',
        editInPlayers: 'Edit in Player character portrait',
        editInEndings: 'Edit in Ending CG',
      },
      sectionCatalog: sectionCatalogEs,
      fieldGroups: {
        public: 'Capa pública',
        secret: 'Capa secreta',
        secretBadge: 'Secreto · oculto al jugador',
      },
      fields: {
        id: 'ID',
        name: 'Nombre',
        type: 'Tipo',
        state: 'Estado',
        label: 'Etiqueta',
        scope: 'Ámbito',
        source: 'Fuente',
        detail: 'Detalle',
        summary: 'Resumen',
        prerequisiteConclusions: 'Conclusiones previas',
        relatedClues: 'Pistas relacionadas',
        content: 'Contenido',
        priority: 'Prioridad',
        target: 'Objetivo',
        targetType: 'Tipo de objetivo',
        mode: 'Modo',
        intent: 'Intención',
        claim: 'Afirmación',
        claims: 'Afirmaciones semánticas',
        mediaTag: 'Media tag',
        referenceAssets: 'Reference assets',
        stageMediaTags: 'Stage portraits',
        phaseKey: 'Stage',
        tag: 'Tag',
        file: 'Archivo',
        objectKey: 'Object key',
        mime: 'MIME',
        width: 'Ancho',
        height: 'Alto',
        packId: 'Pack ID',
        title: 'Título',
        tagline: 'Resumen corto',
        assetManifestId: 'Asset manifest ID',
        videoSceneReferenceTag: 'Imagen de referencia de la escena',
        videoNpcReferenceTag: 'Imagen de referencia del NPC',
        videoPlayerReferenceTag: 'Imagen de referencia del jugador',
        coverTag: 'Portada horizontal (alternativa)',
        portrait_cover_tag: 'Portada vertical (9:16)',
        opening: 'Texto inicial',
        seoTitle: 'Título de lista',
        seoDescription: 'Resumen de lista',
        initialLocation: 'Ubicación inicial',
        none: 'Ninguno',
        initialPhase: 'Fase inicial',
        turnLimit: 'Límite de turnos',
        openingStrategy: 'Estrategia inicial',
        defaultActionMode: 'Modo de acción',
        statsDefinitions: 'Definiciones',
        statId: 'ID',
        statName: 'Nombre',
        statColor: 'Color',
        initialValue: 'Inicial',
        description: 'Descripción',
        statRules: 'Reglas de valores',
        initialStates: 'Estados iniciales',
        stateKey: 'Clave de estado',
        stateValue: 'Valor de estado',
        initialFlags: 'Flags iniciales',
        initialNpcStates: 'Estados NPC iniciales',
        initialQuestStates: 'Estados de misión iniciales',
        initialSceneEventStates: 'Eventos iniciales',
        initialObjectStates: 'Objetos iniciales',
        initialInventory: 'Inventario inicial',
        primaryNpcId: 'NPC principal',
        keeperRole: 'Rol KP',
        dynamicStoryEnabled: 'Activar historia dinámica',
        singleScene: 'Modo de una escena',
        minDistinctTurns: 'Turnos distintos mínimos',
        maxActiveBranches: 'Máximo de ramas activas',
        maxGeneratedEndings: 'Finales generados por partida',
        trackerExpiry: 'Turnos hasta caducar el hilo',
        dynamicStoryPrinciples: 'Principios de historia dinámica',
        dynamicStoryForbidden: 'Restricciones de historia dinámica',
        referenceEndings: 'Finales de referencia',
        referenceEndingsHint: 'Los ejemplos solo se envían al diseñador de ramas, no a los prompts normales de KP o NPC.',
        referenceEnding: 'Final de referencia',
        requiredConsequences: 'Consecuencias requeridas',
        phaseRules: 'Reglas de fase',
        phase: 'Fase',
        principles: 'Principios',
        forbidden: 'Reglas prohibidas',
        hiddenFacts: 'Hechos ocultos',
        displayName: 'Nombre visible',
        publicProfile: 'Perfil público',
        trueProfile: 'Perfil real',
        coverRole: 'Rol de cobertura',
        coverStory: 'Historia de cobertura',
        coverAttitude: 'Actitud de cobertura',
        species: 'Especie',
        origin: 'Origen',
        hunger: 'Deseo',
        limitation: 'Limitación',
        danger: 'Peligro',
        appearance: 'Apariencia',
        publicKnowledge: 'Conocimiento público',
        privateKnowledge: 'Conocimiento privado',
        disclosePolicy: 'Política de revelación',
        boundaries: 'Límites',
        mustDo: 'Debe hacer',
        mustNotDo: 'No debe hacer',
        usable: 'Usable',
        damaged: 'Dañado',
        known: 'Conocido',
        importance: 'Importancia',
        ownerNpc: 'NPC dueño',
        startsUnlocked: 'Desbloqueado al inicio',
        unlockWhen: 'Condición de desbloqueo',
        speakableAs: 'Frases',
        locationId: 'ID de ubicación',
        once: 'Una vez',
        triggerWhen: 'Condición de disparo',
        whenCondition: 'Condición de coincidencia',
        requires: 'Requisitos',
        invalidReason: 'Razón inválida',
        overrideKp: 'Sobrescribir KP',
        stopProcessing: 'Detener reglas',
        targetsAll: 'Todos los objetivos',
        effectsStats: 'Cambios de stats',
        effectsFlags: 'Flags a definir',
        effectsEvidence: 'Evidencia a añadir',
        locationChange: 'Mover a ubicación',
        unlockLocations: 'Desbloquear ubicaciones',
        lockLocations: 'Bloquear ubicaciones',
        addInventory: 'Añadir inventario',
        removeInventory: 'Quitar inventario',
        sceneNarration: 'Narración de escena',
        visibleFindings: 'Hallazgos visibles',
        discoveredObjects: 'Objetos descubiertos',
        npcReaction: 'Política de reacción NPC',
        npcDirectiveNpc: 'NPC indicado',
        npcDirectiveTactic: 'Táctica NPC',
        npcDirectiveMood: 'Estado NPC',
        mustReactTo: 'Debe reaccionar a',
        mustHide: 'Debe ocultar',
        possibleEnding: 'Final inmediato',
        reason: 'Razón',
        valueType: 'Tipo de valor',
        hardState: 'Estado duro',
        writers: 'Escritores',
        readers: 'Lectores',
        runtimeEffect: 'Efecto en runtime',
        notes: 'Notas',
        npcIds: 'NPC IDs',
        objectIds: 'IDs de objeto',
        sceneEventIds: 'IDs de evento',
        connections: 'Conexiones',
        to: 'A',
        locked: 'Bloqueado',
        lockedReason: 'Razón de bloqueo',
        defaultCharacterId: 'Personaje por defecto',
        showInSelection: 'Mostrar en la selección de personaje',
        gender: 'Género',
        age: 'Edad',
        archetype: 'Arquetipo',
        portraitTag: 'Recurso de retrato',
        attributes: 'Atributos',
        skills: 'Habilidades',
        inventory: 'Inventario',
        history: 'Historia',
        traits: 'Rasgos',
        mainQuestId: 'Misión principal',
        statusAtStart: 'Estado inicial',
        steps: 'Pasos',
        completeWhen: 'Condición de completar',
        failWhen: 'Condición de fallo',
        entryTag: 'Entry tag',
        entryIdleTag: 'Entry idle tag',
        defaultTag: 'Default tag',
        defaultIdleTag: 'Default idle tag',
        revealedTag: 'Revealed tag',
        revealedIdleTag: 'Revealed idle tag',
        openingTag: 'Opening CG tag',
        endingBookTag: 'Ending book tag',
        idleTag: 'Idle video tag',
        mood: 'Mood',
        statKey: 'Stat key',
        triggerType: 'Trigger type',
        statePath: 'State path',
        threshold: 'Threshold',
        oncePerRun: 'Once per run',
        triggerScope: 'Trigger scope',
        sortOrder: 'Sort order',
        defaultBgmTag: 'Default BGM tag',
        defaultBgmMood: 'Default BGM mood',
        voiceRole: 'Rol',
        defaultVoice: 'Voz predeterminada',
        inheritDefaultVoice: 'Heredar predeterminada',
        playerVoiceId: 'Voz del jugador',
        npcVoiceId: 'Voz de NPC',
        endingVoiceId: 'Voz del final',
      },
    },
    conditions: conditionMessages.es,
    assets: {
      title: 'Recursos',
      subtitle: 'Gestiona retratos, CG, audio y referencias.',
      file: 'Archivo',
      search: 'Buscar tag, MIME u object key',
      upload: 'Subir recurso',
      uploading: 'Subiendo',
      uploaded: 'Recurso subido',
      uploadFailed: 'Error al subir',
      generateImage: 'Generar imagen',
      generatingImage: 'Generando imagen',
      imageGenerated: 'Imagen generada y guardada como recurso',
      imageGenerationFailed: 'Error al generar la imagen',
      image_purpose: 'Uso de la imagen',
      image_purpose_asset: 'Recurso general',
      image_purpose_portrait_cover: 'Portada vertical',
      portrait_cover_hint: 'Genera una portada 9:16 (1080 × 1920). Después, selecciónala como portada vertical en la configuración del guion.',
      imagePrompt: 'Descripción de la imagen',
      imagePromptHint: 'Seedream generará una imagen 2K y la guardará en este paquete.',
      deleted: 'Recurso eliminado',
      delete: 'Eliminar recurso',
      deleteFailed: 'Error al eliminar',
      openFile: 'Abrir archivo',
      inspect: 'Inspeccionar',
      inspector: 'Inspector de recurso',
      selectAsset: 'Selecciona un recurso para ver vista previa, metadatos y referencias.',
      noPreview: 'Sin vista previa',
      noMetadata: 'Sin metadatos',
      loading: 'Cargando recursos',
      loadFailed: 'Error al cargar recursos',
      emptyTitle: 'Sube el primer retrato o CG',
      empty: 'Sin recursos',
      duplicateTag: 'Este tag ya existe. Usa un tag único.',
      referenceCount: '{count} referencias',
      references: 'Referencias',
      noReferences: 'Ninguna sección referencia este recurso.',
      confirmDeleteTitle: 'Eliminar recurso',
      confirmDeleteBody: 'Este recurso se eliminará del borrador actual.',
      confirmReferencedDeleteBody: 'Este recurso tiene {count} referencias. Se romperán al eliminarlo.',
      confirmTextLabel: 'Escribe {tag} para confirmar',
      confirmDeleteCta: 'Eliminar recurso',
      coverage: {
        total: 'Recursos totales',
        referenced: 'Usados en historia',
        unreferenced: 'Sin uso',
        unreferencedTags: 'Tags sin uso',
        none: 'Todos los recursos están referenciados por campos de historia.',
      },
      filters: { all: 'Todos' },
      groups: { cg: 'CG y cinemáticas', character: 'Personajes y retratos', scene: 'Escenas y referencias', audio: 'Música y SFX', ui: 'Assets de UI', reference: 'Imágenes de referencia', other: 'Otros archivos' },
      types: { image: 'Imagen', video: 'Video', audio: 'Audio', asset: 'Archivo' },
      meta: { type: 'Tipo', mime: 'MIME', dimensions: 'Dimensiones', objectKey: 'Object key', hash: 'Hash' },
    },
    versions: { title: 'Versiones', subtitle: 'Compilar, validar, publicar, revertir y previsualizar.', compile: 'Compilar borrador', compiling: 'Compilando', compileDone: 'Compilación terminada', compileFailed: 'Error al compilar', loadChecksFailed: 'Error al cargar las validaciones', publishDone: 'Versión publicada', publishFailed: 'Error al publicar', previewFailed: 'Error al autorizar la previsualización', rollback: 'Revertir', rollbackDone: 'Revertido', rollbackFailed: 'Error al revertir', checks: 'Validaciones', noChecks: 'La versión seleccionada no tiene validaciones aún. Compila el borrador o selecciona una versión.', version: 'Versión', emptyTitle: 'Aún no hay versiones', empty: 'Aún no hay versiones. Compila el borrador primero.', publishBlocked: 'Corrige las validaciones bloqueantes antes de publicar.', jumpToSection: 'Abrir sección', snapshot: 'Snapshot de compilación', openSnapshot: 'Ver snapshot', closeSnapshot: 'Cerrar snapshot', noSnapshot: 'Esta versión no tiene snapshot de compilación para mostrar.', checkStatus: { ok: 'Correcto', warning: 'Advertencia', error: 'Error', empty: 'Sin validaciones' }, checkSummary: { ok: 'Todas las validaciones pasaron.', warning: '{warnings} advertencias requieren revisión.', error: '{errors} errores bloquean la publicación.', empty: 'Sin validaciones cargadas.' }, confirm: { publishTitle: 'Publicar versión', publishBody: 'Después de publicar, la app de jugador usará esta versión como versión activa.', publishCta: 'Publicar', rollbackTitle: 'Revertir versión', rollbackBody: 'La reversión cambia la versión activa a la seleccionada. Los datos de jugadores no se eliminan.', rollbackAcknowledge: 'Entiendo que esto cambia la versión activa y quiero continuar.', rollbackCta: 'Revertir' } },
    localization: { title: 'Localización del contenido', description: 'Genera o actualiza cada idioma manualmente para la versión seleccionada. Guardar el borrador no inicia traducciones.', externalNotice: 'Al generar, el texto de la historia se envía al modelo de traducción configurado y el resultado se guarda en la tabla de traducciones.', sourceSummary: 'Esta versión contiene {count} textos traducibles.', loading: 'Cargando estado…', loadFailed: 'No se pudo cargar el estado de traducción', generate: 'Generar', generateAll: 'Generar todos los idiomas ({count})', generatingAll: 'Generando todos los idiomas…', batchProgress: 'Procesando idioma {current} de {total} · {completed} completados', generateAllDone: 'Traducciones generadas para {count} idiomas', generateAllFailed: 'Traducción por lotes finalizada: {completed} correctas, {failed} fallidas', allAlreadyDone: 'Todos los idiomas ya están completos', regenerate: 'Volver a generar', generating: 'Generando…', generateDone: 'Traducción generada', generateFailed: 'Error al generar la traducción', progressStatus: { idle: 'Preparando', translating: 'Traduciendo', saving: 'Guardando', completed: 'Completado', failed: 'Error' }, status: { source: 'Idioma de origen', missing: 'Pendiente', ready: 'Completado' }, locales: { 'zh-CN': 'Chino simplificado', en: 'Inglés', ja: 'Japonés', ko: 'Coreano', es: 'Español', pt: 'Portugués' } },
    translationInventory: { title: 'Detalle del contenido', all: 'Todo', pending: 'Pendiente', reused: 'Reutilizado', translated: 'Traducido', source: 'Texto original', target: 'Traducción de destino', notTranslated: 'Aún sin traducir', empty: 'No hay contenido para este filtro.', reuseFrom: 'El contenido sin cambios se reutilizará desde {version}.', reusableCount: '{count} reutilizables', pendingCount: '{count} pendientes' },
    common: { retry: 'Reintentar', refresh: 'Actualizar', open: 'Abrir', close: 'Cerrar', more: 'Más', required: 'Obligatorio' },
  },
}
